<template>
  <div class="physician-item">
    <div
      class="d-flex justify-content-between align-items-center physician-header"
      @click="toggle"
    >
      <div
        class="phys-summary"
        :class="!physician.name ? 'status-alert alert5-success px-3' : ''"
      >
        <span :class="physician.name ? 'font-weight-bold' : ''">{{
          physician.name || "New Physician"
        }}</span>
        <small class="text-muted ml-2">{{ physician.type }}</small>
        <div class="text-muted small">{{ physician.phone }}</div>
      </div>
      <div>
        <button
          type="button"
          class="btn btn-link btn-sm text-black"
          @click.stop="toggle"
        >
          <i
            class="fas"
            :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
          ></i>
        </button>
        <button
          type="button"
          class="btn btn-link text-danger btn-sm"
          @click.stop.prevent="removeItem"
        >
          <i class="fas fa-trash-alt" title="Remove"></i>
        </button>
      </div>
    </div>

    <div v-if="isOpen" class="mt-2">
      <div @keydown.enter.prevent>
        <input-control
          type="horizontal"
          v-model="local.name"
          control="text"
          :wrapClass="nameError ? 'phys-name-error' : ''"
          labelClass="col-md-3 col-lg-2"
          :disabled="disabled"
          >Name</input-control
        >
        <input-control
          type="horizontal"
          v-model="local.type"
          control="text"
          labelClass="col-md-3 col-lg-2"
          :disabled="disabled"
          >Type</input-control
        >

        <input-control
          type="horizontal"
          v-model="local.phone"
          control="text"
          :cleave="cleave.phone"
          labelClass="col-md-3 col-lg-2"
          :disabled="disabled"
          >Phone</input-control
        >

        <input-control
          type="horizontal"
          v-model="local.email"
          control="email"
          labelClass="col-md-3 col-lg-2"
          :disabled="disabled"
          >Email</input-control
        >
        <div v-if="emailError" class="text-danger small mb-2">
          Please enter a valid email address.
        </div>

        <div v-if="nameError" class="text-danger small mb-2">
          Name is required.
        </div>

        <div class="mt-2">
          <button
            type="button"
            class="btn btn-sm btn-theme"
            @click.prevent="save"
            :disabled="disabled"
          >
            Validate & Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputControl from "@/components/InputControl.vue";

export default {
  name: "PhysicianItem",
  components: { InputControl },
  props: {
    physician: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      local: Object.assign({}, this.physician || {}),
      // internal expansion state when prop `expanded` is not provided (null)
      isExpanded: !(
        (this.physician || {}).name && (this.physician || {}).name.trim() !== ""
      ),
      nameError: false,
      cleave: {
        phone: { blocks: [20], numericOnly: true },
      },
    };
  },
  watch: {
    physician: {
      handler(v) {
        if (v && v.id !== this.local.id) {
          this.local = Object.assign({}, v || {});
        }
      },
      deep: true,
    },
    "local.name": function (v) {
      if (v && v.toString().trim() !== "") this.nameError = false;
    },
  },
  computed: {
    isOpen() {
      // If parent provides explicit expanded prop (true/false), use it; otherwise use internal state
      return this.expanded === null ? this.isExpanded : !!this.expanded;
    },
  },
  methods: {
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    toggle() {
      if (this.expanded === null) {
        this.isExpanded = !this.isExpanded;
      } else {
        // notify parent to toggle per-item expanded marker
        this.$emit("toggle-expanded", this.index);
      }
    },
    save() {
      this.nameError = !this.local.name || this.local.name.trim() === "";
      this.emailError =
        !this.local.email || !this.isValidEmail(this.local.email);

      if (this.nameError || this.emailError) return;
      const payload = Object.assign({}, this.local);
      payload.__expanded = false;
      this.$emit("change", payload);
      if (this.expanded === null) this.isExpanded = false;
    },
    removeItem() {
      this.$emit("remove", this.index);
    },
  },
};
</script>

<style scoped lang="scss">
.phys-summary {
  small {
    margin-left: 0.5rem;
  }
}
.physician-header {
  cursor: pointer;
}
</style>

<style lang="scss">
.phys-name-error {
  input {
    border-color: rgba(220, 53, 69, 0.5) !important;
  }
}
</style>
